import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { AiOutlineCheck } from 'react-icons/ai';
import {
    generateDetail,
    getCards,
    getGenerateProgress,
    getMagicPrompt,
    getTaskDetail,
    selectCandidate,
} from '../../../utils/net';
import style from './generateBoard.module.css';
import Private from '../../widgets/Private';
import License from '../../widgets/License';
import {
    cardsAtom,
    cardsTypeAtom,
    lastGenerateUUIDAtom,
    modalObjAtom,
    prohibitAtom,
    promptAtom,
    regenePrivateSetAtom,
    setGenerateAtom,
    showProgressAtom,
    showRegenerateAtom,
    stopChatAtom,
    taskDetailAtom,
    taskInitAtom,
    walletInfoAtom,
    userPermissionAtom,
    lastGenerateInfoAtom,
    showWalletAtom,
    textGenerateAtom,
    promptKeyWordsAtom,
} from '../../../store';
import { stylizedArr } from '../../../utils/map';
import { XscrollEasy } from '../../widgets/XscrollEasy';
import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import * as Sentry from "@sentry/react";
import { useTranslation } from "react-i18next";
import { trackEvent } from '../../../utils/trackEvent'
import { useDebounce } from '../../../utils/hooks';


const PromptSelectComponent = ({ allStrings, setSelectedStrings, selectedStrings }) => {
    const { t } = useTranslation();
    const taskInit = useRecoilValue(taskInitAtom);
    const renderStringSelections = () => {
        const strings = allStrings;
        const handleClick = (string) => {
            if (selectedStrings.includes(string)) {
                trackEvent('ChatAvatar - Chat - Default Prompt: Switch', { promptSelect:selectedStrings.filter((item) => item !== string) }, taskInit.task_uuid)
                setSelectedStrings(selectedStrings.filter((item) => item !== string));
            } else {
                trackEvent('ChatAvatar - Chat - Default Prompt: Switch', { promptSelect:[...selectedStrings, string] }, taskInit.task_uuid)
                setSelectedStrings([...selectedStrings, string]);
            }
        };

        return (
            <div className={style.stringSelectionContainer}>
                {strings.map((string, index) => (
                    <button
                        key={index}
                        className={`${style.stringSelectionButton} ${selectedStrings.includes(string) ? style.selected : ''
                            }`}
                        onClick={handleClick.bind(null, string)}
                    >
                        {string}
                        {selectedStrings.includes(string) && (
                            <AiOutlineCheck className={style.checkIcon} />
                        )}
                    </button>
                ))}
            </div>
        );
    };

    return (
        <div className={style.promptContent}>
            {renderStringSelections()}
            <div className={`${style.generateTips}`}>
                <p>
                    {t('CHATAVATAR_BOARD_TIPS_1')}
                </p>
                <p>
                    {t('CHATAVATAR_BOARD_TIPS_2')}
                </p>
                <p>
                    {t('CHATAVATAR_BOARD_TIPS_3')}
                    {' '}
                </p>
            </div>
        </div>
    )
}

const StylizedComponent = ({ currentStylized, setCurrentStylized }) => {
    const fitheightRef = new Array(6).fill(0).map(() => useRef(null))
    const taskInit = useRecoilValue(taskInitAtom);
    const { t } = useTranslation();

    useEffect(() => {
        localStorage.removeItem('showNewStyliezd')
        if (!localStorage.getItem('showNewStyliezd2')) {
            setTimeout(() => {
                driverGuide()
                localStorage.setItem('showNewStyliezd2', true)
            }, 300);
        }

    }, [])

    const driverGuide = () => {
        const driverObj = new driver({
            overlayColor: 'rgba(0,0,0,0.6)',
            onDestroyStarted: () => {
                driverObj.destroy();
            },
        });
        driverObj.highlight({
            element: "#newStylizedTab",
            popover: {
                description: t('DRIVEROBJ_STYLIZED_DESC'),
                popoverClass: "newStylizedDriver"
            }
        });
    }

    const unfoldHeight = (index) => {
        let fitheight = fitheightRef[index].current
        fitheight.style.height = 'auto'
        const { height } = fitheight.getBoundingClientRect()
        fitheight.style.height = 0
        fitheight.style.transition = '.2s ease'
        fitheight.offsetHeight   //读取属性，重新赋值height
        fitheight.style.height = Math.floor(height + 10) + 'px'
    }

    const handlerMouseEnter = (src, index) => {
        if (!src) return
        unfoldHeight(index)
    }

    const handlerMouseLeave = (src, index) => {
        if (!src) return
        let fitheight = fitheightRef[index].current
        fitheight.style.height = 0
        fitheight.style.transition = '.3s'
    }

    const handlerSetCurrentStylized = (index) => {
        trackEvent('ChatAvatar - Chat - Model Type: Switch', { currentStylized:index }, taskInit.task_uuid)
        setCurrentStylized(index)
    }

    return (
        <XscrollEasy>
            <div className={style.newStylizedTab} id='newStylizedTab' style={{
                display: "flex",
                gap: "8px",
            }}>
                {stylizedArr.slice(0, 3).map((item, index) => {
                    return (
                        <div
                            className={`${style.xscrollItem} ${currentStylized === index ? style.active : ""}`}
                            key={index}
                            onClick={handlerSetCurrentStylized.bind(null, index)}
                            onMouseEnter={handlerMouseEnter.bind(null, item?.src, index)}
                            onMouseLeave={handlerMouseLeave.bind(null, item?.src, index)}
                        >
                            <div className={`${style.infoBox}`}>
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clipPath="url(#clip0_15938_12543)">
                                        <path d="M1.09916 5.01199C1.09916 3.46079 2.35676 2.20319 3.90796 2.20319C5.02396 2.20319 5.98716 2.85359 6.44076 3.79599C7.46249 3.49503 8.54875 3.49087 9.57276 3.78399C10.0288 2.84879 10.9888 2.20399 12.0992 2.20399C13.6504 2.20399 14.908 3.46159 14.908 5.01279C14.908 6.09839 14.292 7.03919 13.3912 7.50639C13.5607 8.04998 13.6468 8.61616 13.6464 9.18559C13.6464 12.2888 11.1312 14.804 8.02796 14.804C4.92476 14.804 2.40956 12.2888 2.40956 9.18559C2.40956 8.60879 2.49676 8.05279 2.65836 7.52879C1.73436 7.06799 1.09916 6.11439 1.09916 5.01199ZM4.93116 10.5152C5.27676 11.6576 6.53756 12.456 7.99836 12.456C9.49356 12.456 10.7616 11.6344 11.0824 10.4576C11.1912 10.0592 10.956 9.64799 10.5576 9.53999C10.1592 9.43119 9.74796 9.66639 9.63996 10.0648C9.52156 10.4992 8.90636 10.9608 7.99916 10.9608C7.10876 10.9608 6.49196 10.5088 6.36316 10.0832C6.24396 9.68799 5.82636 9.46399 5.43116 9.58399C5.03516 9.70239 4.81196 10.12 4.93116 10.5152Z" fill="#676767" />
                                        <path d="M2.06556 4.2976C2.06556 3.78799 2.10396 3.288 2.17836 2.7992C2.67157 2.41178 3.28078 2.20157 3.90796 2.2024C5.02396 2.2024 5.98716 2.8528 6.44076 3.7952C7.46249 3.49424 8.54875 3.49008 9.57276 3.7832C10.0288 2.848 10.9888 2.2032 12.0992 2.2032C13.6504 2.2032 14.908 3.4608 14.908 5.012C14.908 6.0976 14.292 7.0384 13.3912 7.5056C13.5607 8.04919 13.6468 8.61537 13.6464 9.1848C13.6464 11.3168 12.4584 13.1712 10.7088 14.1232C6.95756 13.6464 3.86236 11.072 2.63436 7.6128L2.65836 7.528C2.63596 7.5168 2.61356 7.504 2.59116 7.492C2.25116 6.4896 2.06556 5.4152 2.06556 4.2976ZM4.93116 10.5152C5.27676 11.6576 6.53756 12.456 7.99836 12.456C9.49356 12.456 10.7616 11.6344 11.0824 10.4576C11.1912 10.0592 10.956 9.648 10.5576 9.54C10.1592 9.4312 9.74796 9.6664 9.63996 10.0648C9.52156 10.4992 8.90636 10.9608 7.99916 10.9608C7.10876 10.9608 6.49196 10.5088 6.36316 10.0832C6.24396 9.688 5.82636 9.464 5.43116 9.584C5.03516 9.7024 4.81196 10.12 4.93116 10.5152Z" fill="#676767" />
                                        <path d="M6.44076 3.79519C7.46249 3.49423 8.54875 3.49007 9.57276 3.78319C10.0288 2.84799 10.9888 2.20319 12.0992 2.20319C13.6504 2.20319 14.908 3.46079 14.908 5.01199C14.908 6.09759 14.292 7.03839 13.3912 7.50559C13.5607 8.04918 13.6468 8.61536 13.6464 9.18479C13.6464 9.67759 13.5824 10.1552 13.4632 10.6112C12.6256 10.5088 11.8208 10.3016 11.0608 10.004C10.98 9.78479 10.7984 9.60639 10.556 9.54079C10.3976 9.49759 10.2376 9.50959 10.0952 9.56319C7.38556 8.14639 5.41356 5.51199 4.90396 2.38559C5.57803 2.641 6.12821 3.14563 6.44076 3.79519Z" fill="#676767" />
                                        <path d="M9.62316 3.68799C10.0968 2.80479 11.0272 2.20319 12.0992 2.20319C13.6504 2.20319 14.908 3.46079 14.908 5.01199C14.908 5.67199 14.6792 6.27759 14.2984 6.75679C12.456 6.19839 10.84 5.11839 9.62316 3.68799Z" fill="#676767" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_15938_12543">
                                            <rect width="16" height="16" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                                <span> {item.name}</span>
                            </div>
                            {item?.src && (
                                <div className={style.imgBox}
                                    ref={fitheightRef[index]}
                                >
                                    <img src={item.src} alt={item.src} />
                                </div>
                            )}
                        </div>
                    )
                })}
            </div>
            {stylizedArr.slice(3, 4).map((item) => {
                return (
                    <div
                        className={`${style.xscrollItem} ${currentStylized === 3 ? style.active : ""}`}
                        key={2}
                        onClick={handlerSetCurrentStylized.bind(null, 3)}
                    >
                        <div className={`${style.infoBox} ${item.className ? item.className : ''}`}>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clipPath="url(#clip0_15938_12543)">
                                    <path d="M1.09916 5.01199C1.09916 3.46079 2.35676 2.20319 3.90796 2.20319C5.02396 2.20319 5.98716 2.85359 6.44076 3.79599C7.46249 3.49503 8.54875 3.49087 9.57276 3.78399C10.0288 2.84879 10.9888 2.20399 12.0992 2.20399C13.6504 2.20399 14.908 3.46159 14.908 5.01279C14.908 6.09839 14.292 7.03919 13.3912 7.50639C13.5607 8.04998 13.6468 8.61616 13.6464 9.18559C13.6464 12.2888 11.1312 14.804 8.02796 14.804C4.92476 14.804 2.40956 12.2888 2.40956 9.18559C2.40956 8.60879 2.49676 8.05279 2.65836 7.52879C1.73436 7.06799 1.09916 6.11439 1.09916 5.01199ZM4.93116 10.5152C5.27676 11.6576 6.53756 12.456 7.99836 12.456C9.49356 12.456 10.7616 11.6344 11.0824 10.4576C11.1912 10.0592 10.956 9.64799 10.5576 9.53999C10.1592 9.43119 9.74796 9.66639 9.63996 10.0648C9.52156 10.4992 8.90636 10.9608 7.99916 10.9608C7.10876 10.9608 6.49196 10.5088 6.36316 10.0832C6.24396 9.68799 5.82636 9.46399 5.43116 9.58399C5.03516 9.70239 4.81196 10.12 4.93116 10.5152Z" fill="#676767" />
                                    <path d="M2.06556 4.2976C2.06556 3.78799 2.10396 3.288 2.17836 2.7992C2.67157 2.41178 3.28078 2.20157 3.90796 2.2024C5.02396 2.2024 5.98716 2.8528 6.44076 3.7952C7.46249 3.49424 8.54875 3.49008 9.57276 3.7832C10.0288 2.848 10.9888 2.2032 12.0992 2.2032C13.6504 2.2032 14.908 3.4608 14.908 5.012C14.908 6.0976 14.292 7.0384 13.3912 7.5056C13.5607 8.04919 13.6468 8.61537 13.6464 9.1848C13.6464 11.3168 12.4584 13.1712 10.7088 14.1232C6.95756 13.6464 3.86236 11.072 2.63436 7.6128L2.65836 7.528C2.63596 7.5168 2.61356 7.504 2.59116 7.492C2.25116 6.4896 2.06556 5.4152 2.06556 4.2976ZM4.93116 10.5152C5.27676 11.6576 6.53756 12.456 7.99836 12.456C9.49356 12.456 10.7616 11.6344 11.0824 10.4576C11.1912 10.0592 10.956 9.648 10.5576 9.54C10.1592 9.4312 9.74796 9.6664 9.63996 10.0648C9.52156 10.4992 8.90636 10.9608 7.99916 10.9608C7.10876 10.9608 6.49196 10.5088 6.36316 10.0832C6.24396 9.688 5.82636 9.464 5.43116 9.584C5.03516 9.7024 4.81196 10.12 4.93116 10.5152Z" fill="#676767" />
                                    <path d="M6.44076 3.79519C7.46249 3.49423 8.54875 3.49007 9.57276 3.78319C10.0288 2.84799 10.9888 2.20319 12.0992 2.20319C13.6504 2.20319 14.908 3.46079 14.908 5.01199C14.908 6.09759 14.292 7.03839 13.3912 7.50559C13.5607 8.04918 13.6468 8.61536 13.6464 9.18479C13.6464 9.67759 13.5824 10.1552 13.4632 10.6112C12.6256 10.5088 11.8208 10.3016 11.0608 10.004C10.98 9.78479 10.7984 9.60639 10.556 9.54079C10.3976 9.49759 10.2376 9.50959 10.0952 9.56319C7.38556 8.14639 5.41356 5.51199 4.90396 2.38559C5.57803 2.641 6.12821 3.14563 6.44076 3.79519Z" fill="#676767" />
                                    <path d="M9.62316 3.68799C10.0968 2.80479 11.0272 2.20319 12.0992 2.20319C13.6504 2.20319 14.908 3.46079 14.908 5.01199C14.908 5.67199 14.6792 6.27759 14.2984 6.75679C12.456 6.19839 10.84 5.11839 9.62316 3.68799Z" fill="#676767" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_15938_12543">
                                        <rect width="16" height="16" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                            <span> {item.name}</span>
                        </div>
                    </div>
                )
            })}
        </XscrollEasy>
    )
}

const CandidateConComponent = ({ candidates, setCountdown }) => {
    const taskInit = useRecoilValue(taskInitAtom);
    const location = useLocation();
    const navi = useNavigate();

    const handleSelectCandidate = async (candidateIndex) => {
        // return null
        await selectCandidate(taskInit.task_uuid, candidateIndex);
        setCountdown(0);
        let path = '/chatavatar'
        if (location.pathname.includes('/loreal')) path = '/loreal'
        navi(path, {
            state: {
                type: 'detail',
                taskuuid: taskInit.task_uuid,
            },
        });
        // window.history.pushState(null, '', '/')
    };

    return (
        <div className={style.candidateCon} data-cy="generate-candidate">
            <div className={style.candidateCol}>
                {candidates.map((item, index) => (index >= 0 && index < 3 ? (
                    <img
                        key={index}
                        src={`data:image/png;base64,${item}`}
                        alt={item}
                        onClick={handleSelectCandidate.bind(null, index)}
                    />
                ) : null))}
            </div>
            <div className={style.candidateCol}>
                <div style={{ height: '4rem', marginBottom: '1rem' }} />
                {candidates.map((item, index) => (index >= 3 && index < 6 ? (
                    <img
                        key={index}
                        src={`data:image/png;base64,${item}`}
                        alt={item}
                        onClick={handleSelectCandidate.bind(null, index)}
                    />
                ) : null))}
            </div>
            <div className={style.candidateCol}>
                {candidates.map((item, index) => (index >= 6 && index < 9 ? (
                    <img
                        key={index}
                        src={`data:image/png;base64,${item}`}
                        alt={item}
                        onClick={handleSelectCandidate.bind(null, index)}
                    />
                ) : null))}
            </div>
        </div>
    )
}

const SeedComponent = ({ seeds, setSeeds }) => {

    const handleSeeds = (ev) => {
        setSeeds(ev.currentTarget.value);
    };

    const handlerInputClick = () => _czc.push(['_trackEvent', 'Card', 'Customize Seed Change', 'Generate Card',]);

    return (

        <input
            className={style.seedsArea}
            value={seeds}
            data-cy="generate-seed-input"
            placeholder="Customized Seed"
            onChange={handleSeeds}
            onClick={handlerInputClick}
            style={{ textAlign: 'center' }}
            type="number"
        />
    )
}

function GenerateBoard() {
    const intervalRef = useRef(null);
    const LicenseRef = useRef(null);
    const PrivateRef = useRef(null);
    const colLayoutRef = useRef(null);
    const mainInfoWrapperRef = useRef(null);
    const selectionCountInterval = useRef(null);
    const [candidates, setCandidates] = useState([]);
    const [countdown, setCountdown] = useState(10);
    const [selectedStrings, setSelectedStrings] = useState([]);
    const [allStrings, setAllStrings] = useState([]);
    const [showModelAndPrompt, setShowModelAndPrompt] = useState(true);
    const textGenerate = useRecoilValue(textGenerateAtom);
    const [showProgress, setShowProgress] = useRecoilState(showProgressAtom);
    const [lastGenerateInfo, setLastGenerateInfo] = useRecoilState(lastGenerateInfoAtom);
    const taskInit = useRecoilValue(taskInitAtom);
    const cardsType = useRecoilValue(cardsTypeAtom);
    const setProhibit = useSetRecoilState(prohibitAtom);
    const setCards = useSetRecoilState(cardsAtom);
    const userPermission = useRecoilValue(userPermissionAtom);
    const [walletInfo, setWalletInfo] = useRecoilState(walletInfoAtom);
    const setShowWallet = useSetRecoilState(showWalletAtom);
    const setLastGenerateUUID = useSetRecoilState(lastGenerateUUIDAtom);
    const setShowRegenerate = useSetRecoilState(showRegenerateAtom);
    const setPromptKeyWords = useSetRecoilState(promptKeyWordsAtom);
    const [taskDetail, setTaskDetail] = useRecoilState(taskDetailAtom);
    const [prompt, setPrompt] = useRecoilState(promptAtom);
    const [generateProgress, setGenerateProgress] = useState({});
    const [stopChat, setStopChat] = useRecoilState(stopChatAtom);
    const [generate, setGenerate] = useRecoilState(setGenerateAtom);
    const regenePrivateSet = useRecoilValue(regenePrivateSetAtom);
    const [rePrivate, setRePrivate] = useState(false);
    const [seeds, setSeeds] = useState(0);
    const [currentCheckTypeIndex, setCurrentCheckTypeIndex] = useState(0);
    const [modalObj, setModalObj] = useRecoilState(modalObjAtom);
    const [currentStylized, setCurrentStylized] = useState(0);
    const [layoutType, setLayoutType] = useState(0);
    const { t } = useTranslation();
    const setMagicPrompt = async () => {
        try {
            const res = await getMagicPrompt();
            if (res.data.settings.magic_prompts) {
                setAllStrings(res.data.settings.magic_prompts);
            } else {
                throw new Error("Unable to fetch magic prompts")
            }
        } catch (e) {
            Sentry.captureException(e)
        }
    };

    useEffect(() => {

        return () => {
            setWalletInfo({
                uuid: localStorage.getItem('group_uuid'),
                type: 'Group',
                confirm: false
            })
        }
    }, [])


    useEffect(() => {
        if (allStrings.length) {
            const parentElem = mainInfoWrapperRef.current;
            const childElem = colLayoutRef.current
            const parentHeight = parentElem?.clientHeight;
            const childrenHeight = childElem?.clientHeight;
            if (childrenHeight >= parentHeight) {
                setLayoutType(1)
            }
        }
    }, [allStrings])

    useEffect(() => {
        if (modalObj.state) setMagicPrompt();
        setSeeds('');
    }, [modalObj]);

    useEffect(() => {
        if (regenePrivateSet.privatedChange) {
            setRePrivate(regenePrivateSet.currentPrivate);
        }
    }, [regenePrivateSet]);

    useEffect(() => {
        if (taskDetail || !stopChat) {
            clearInterval(intervalRef.current);
            return;
        }
        clearInterval(intervalRef.current);

        intervalRef.current = setInterval(async () => {
            const { data } = await getGenerateProgress(taskInit.task_uuid);
            if (data?.candidates && stylizedArr[currentStylized].selection) setCandidates(data.candidates);
            if (['Done', 'Preview'].includes(data?.stage)) {
                setGenerateProgress({
                    stage: 'Downloading',
                    percent: 100,
                    payload: data,
                });
                const response = await getTaskDetail(taskInit.task_uuid);

                setTaskDetail(response.data);
                clearInterval(intervalRef.current);
                setGenerate(false);
                setProhibit(false);
                if (['Mine', 'Group'].includes(cardsType)) {
                    let count = 0
                    const timer = setInterval(async () => {
                        const rep = await getCards({
                            type: cardsType,
                            page_num: 0,
                            user_type: cardsType === 'Mine' ? 'All' : null
                        });
                        if (count === 0) {
                            setCards(rep.data)
                        }
                        if (
                            rep?.data?.[0]?.image_url
                            && rep?.data?.[0]?.video_url
                            && rep?.data?.[0]?.image_url !== 'FILE_NOT_FOUND'
                            && rep?.data?.[0]?.video_url !== 'FILE_NOT_FOUND'
                        ) {
                            clearInterval(timer);
                            setCards(rep.data)
                        }
                        count++
                    }, 2000);
                }
            } else {
                setGenerateProgress({
                    stage: data.stage,
                    percent: data.percentage || 0,
                    payload: data,
                });
            }
        }, 2000);
        // eslint-disable-next-line
    }, [stopChat]);

    const chooseWallet = () => {
        if (!prompt || stopChat) return;
        userPermission.chatavatar_tab_group ? setShowWallet({
            open: true,
            type: 'text'
        }) : handleGenerate()
    }

    useEffect(() => {
        if (textGenerate) {
            handleGenerate()
        }
    }, [textGenerate])

    const handleGenerate = useDebounce(async () => {
        // if (!prompt || stopChat) return;
        _czc.push(['_trackEvent', 'Card', 'Generate', 'Generate Card']);
        _czc.push(['_trackPageview', '/chatavatar/generate', window.location.href]);

        const modifiedPrompt = prompt
            + (selectedStrings.length > 0 ? ', ' : '')
            + selectedStrings.join(', ');

        try {
            const seed = seeds && seeds.length > 0 ? seeds : Math.floor(Math.random() * 10000);
            const params = {
                task_uuid: taskInit.task_uuid,
                prompt: modifiedPrompt,
                seed,
                ...stylizedArr[currentStylized].param

            }
            if (userPermission.chatavatar_tab_group && walletInfo.type === 'Group') {
                params.group_uuid = localStorage.getItem('group_uuid')
            }
            const rep = await generateDetail(params);
            if (rep.data.error) {
                throw new Error(rep.data.error);
            } else {
                if (LicenseRef.current) {
                    await LicenseRef.current.pay(taskInit.task_uuid);
                }
                if (PrivateRef.current) {
                    await PrivateRef.current.setPrivateDelay(taskInit.task_uuid);
                }

            }
        } catch (e) {
            Sentry.captureException(e)
            setStopChat(false);
        }
        setLastGenerateUUID(taskInit.task_uuid);
        setShowRegenerate(true);
        setShowModelAndPrompt(false);
        setStopChat(true);
        setGenerate(true);
        setProhibit(true);
        setPrompt(prompt);
        setLastGenerateInfo({
            privateType: "",
            privateStatus: false,
            licenseStatus: false,
        })
        if (stylizedArr[currentStylized].selection) {
            selectionCountInterval.current = setInterval(() => {
                setCountdown(pre => pre - 1);
            }, 1000);
        } else {
            setCandidates([]);
            setShowProgress(true);
        }
    }, 100);

    useEffect(() => {
        if (countdown <= 0) {
            clearInterval(selectionCountInterval.current)
            setCandidates([]);
            setShowProgress(true);
        }
    }, [countdown])


    const handleDebouncedInput = useDebounce((value) => {
        setPromptKeyWords(value)
    }, 300);

    useEffect(() => {
        handleDebouncedInput(prompt);
    }, [prompt]);

    const handleIpt = (ev) => {
        if (generate) return;
        setPrompt(ev.currentTarget.value)
    };

    useEffect(() => {
        if (generateProgress.percent === 100) {
            setModalObj({
                ...modalObj,
                type: 'DreamFace',
                state: true
            });
        }
    }, [generateProgress.percent])

    if (showProgress) {
        return (
            <div className={style.generateBox}>
                <div className={style.modelInfoCon}>
                    <div className={style.progressInfo}>{generateProgress.stage}</div>
                    <div className={style.progressTrack}>
                        <div className={style.progressAnimation} />
                        <div
                            className={style.progressThumb}
                            style={{ width: `${generateProgress.percent}%` }}
                        />
                    </div>
                </div>
            </div>
        )
    }

    const handlerSetCheckType = (index) => setCurrentCheckTypeIndex(index)

    const rowLayout = (
        <div className={style.rowLayoutWrapper}>
            <div className={style.checkTypeBox}>
                {['Model', 'Prompt'].map((item, index) => {
                    return (
                        <span
                            className={`${style.checkType} ${currentCheckTypeIndex === index ? style.active : ""}`}
                            key={index}
                            onClick={handlerSetCheckType.bind(null, index)}>
                            {item}
                        </span>
                    )
                })}
            </div>
            {
                currentCheckTypeIndex === 1 ? (
                    <PromptSelectComponent
                        allStrings={allStrings}
                        selectedStrings={selectedStrings}
                        setSelectedStrings={setSelectedStrings} />
                ) : (
                    <StylizedComponent
                        currentStylized={currentStylized}
                        setCurrentStylized={setCurrentStylized} />
                )
            }
        </div>
    )
    const colLayout = (
        <div className={style.colLayoutWrapper} ref={colLayoutRef}>
            <div className={style.modelWrapper}>
                <span className={style.tips}>Model</span>
                <StylizedComponent
                    currentStylized={currentStylized}
                    setCurrentStylized={setCurrentStylized} />
            </div>
            <div className={style.promptWrapper}>
                <span className={style.tips}>Prompt</span>
                <PromptSelectComponent
                    allStrings={allStrings}
                    selectedStrings={selectedStrings}
                    setSelectedStrings={setSelectedStrings} />
            </div>
        </div>
    )

    const handlerTextareaClick = () => _czc.push(['_trackEvent', 'Card', 'Customize Prompt', 'Generate Card',]);

    return (
        <>
            <div className={style.generateBox}>
                <div className={style.titleBox}>
                    <div className={style.title}>Prompt</div>

                    <License
                        style={{
                            top: '2px',
                        }}
                        immediate={false}
                        ref={LicenseRef}
                    />
                    <div className={style.spaceholder} />

                    <Private card={{ is_private: lastGenerateInfo.privateType ? lastGenerateInfo.privateStatus : rePrivate }} type={lastGenerateInfo.privateType === 'Group' ? "group" : "generate"} ref={PrivateRef} />
                </div>
                <textarea
                    disabled={generate}
                    className={style.iptArea}
                    value={prompt}
                    placeholder={t('CHATAVATAR_BOARD_PROMPT_PLACEHOLDER')}
                    onChange={handleIpt}
                    data-cy="generate-prompt-input"
                    onClick={handlerTextareaClick}
                />
                <div
                    className={`${style.btn}  ${!prompt || stopChat ? style.disabled : ''}`}
                    onPointerDown={chooseWallet}
                    data-cy="generate-exec"
                >
                    Generate
                </div>
                <div className={style.mainInfoWrapper} ref={mainInfoWrapperRef}>
                    {showModelAndPrompt ? (
                        <>
                            {layoutType === 0 ? colLayout : rowLayout}
                        </>
                    ) : (
                        <CandidateConComponent
                            candidates={candidates}
                            setCandidates={setCandidates}
                            setCountdown={setCountdown} />
                    )}
                </div>

                <div className={style.bottomBox}>
                    {showModelAndPrompt && <SeedComponent seeds={seeds} setSeeds={setSeeds} />}
                    {stopChat ? (
                        <div
                            className={`${stopChat && countdown > 0 && generateProgress.stage !== 'Waiting'
                                ? style.modelInfoConWithBackground
                                : style.modelInfoCon
                                }`}
                        >
                            {stopChat && countdown > 0 && generateProgress.stage !== 'Waiting' ? (
                                <>
                                    <div className={style.progressInfo}>
                                        {t('CHATAVATAR_BOARD_PRGRESS_INFO')}
                                        {' '}
                                        {countdown}
                                        s
                                    </div>
                                    <div className={style.progressTrack}>
                                        <div
                                            className={style.progressThumb}
                                            style={{ width: `${countdown * 10}%` }}
                                        />
                                    </div>
                                </>
                            ) : null}
                            {generateProgress.stage === 'Waiting' ? (
                                <div className={style.progressInfo}>
                                    {t('CHATAVATAR_BOARD_PRGRESS_WAIT_INFO_1')},
                                    {' '}
                                    {generateProgress?.payload?.waiting_num
                                        ? generateProgress?.payload?.waiting_num
                                        : 0}
                                    {' '}
                                    {t('CHATAVATAR_BOARD_PRGRESS_WAIT_INFO_2')}...
                                </div>
                            ) : null}
                        </div>
                    ) : null}
                </div>

            </div>
        </>
    );
}

export { GenerateBoard };
